import { QueryClient } from "@tanstack/query-core";
import { MutationCache } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";

const backoffDelay = (attempt: number) => Math.min(1000 * 2 ** attempt, 30000);

const nonRetryableStatusCodes = [401, 403];

const shouldRetry = (failureCount: number, error: unknown) => {
	if (error instanceof AxiosError) {
		const status = error.response?.status;
		if (status !== undefined && nonRetryableStatusCodes.includes(status)) {
			return false;
		}
	}
	return failureCount < 3;
};

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			networkMode: "always",
			staleTime: 1000 * 60 * 5,
			retry: shouldRetry,
			retryDelay: backoffDelay,
		},
	},
	mutationCache: new MutationCache({
		onError: (error) => {
			if (error instanceof AxiosError && error.response) {
				const errorMessage = error.response.data?.message || 'An error occurred';
				toast.error(errorMessage);
			}
		},
		onSuccess: (data, variables, context, mutation) => {
			const successMessage = mutation.options.meta?.successMessage;
			if (typeof successMessage === 'string') {
				toast.success(successMessage);
			}
		},
	}),
});
